import { Box, useTheme } from "@mui/material";
import { Link, TitleProps } from "@refinedev/core";
import { GatewayLogoIcon, GatewayLogoText } from "../icons/gateway-logo";

export const Title: React.FC<TitleProps> = ({ collapsed }) => {
  const theme = useTheme();

  return (
    <Link to="/" style={{ textDecoration: "none" }}>
      <Box
        display="flex"
        alignItems="center"
        gap={"12px"}
        sx={{
          color: "text.primary",
        }}
      >
        {collapsed ? (
          <GatewayLogoIcon />
        ) : (
          <>
            <GatewayLogoIcon size={30} />
            <GatewayLogoText />
          </>
        )}
      </Box>
    </Link>
  );
};
